<template>
  <div class="tables">
    <div class="tabelLists" :class="pageFlag ? '' : 'tabelLists-tow'">
      <el-table
        :data="tableData"
        ref="mytable"
        style="width: 100%"
        :height="tabelHeight"
        @selection-change="handleSelectionPersonnel"
        @row-click='selectThisRow'
        highlight-current-row
        :default-sort="{prop: 'roleId', order: 'descending'}"
        @select="select"
      >
        <el-table-column v-if="serial" label="序号" width="55" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="selection"
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <template v-if="cloumns">
          <el-table-column
            v-for="(col, i) in cloumns"
            :key="i"
            :prop="col.prop"
            :label="col.label"
            :width="col.width"
            :min-width="col.minWidth"
            :show-overflow-tooltip="col.show"
            align="center"
          >
          </el-table-column>
       </template>
        <slot></slot>
        <slot name="operate"></slot>
      </el-table>
    </div>
    <div class="bottom-div">
      <div class="crumbs"><slot name="crumbs"></slot></div>
      <div class="pagenation" v-if="pageFlag">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, total, jumper"
          prev-text="上一页"
          next-text="下一页"
          :total="totalNum"
        >
        </el-pagination>
      </div>
      <div class="rigth-div"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dataTable",
  // props: ["tableData", "cloumns", "countFlag"],
  props: {
    tableData: {
      required: true,
      type: Array,
    },
    cloumns: {
      required: true,
      type: Array,
    },
    serial: {
      default: false,
    },
    selection: {
      default: false,
    },
    highlightCurrentRow: {
      default: true,
    },
    countFlag: {
      default: true,
    },
    pageFlag: {
      default: false,
    },
    currentPage: {
      default: 1,
    },
    pageSize: {
      default: 10,
    },
    totalNum: {
      default: 0,
    },
    tabelHeight: {
      default: '100%',
    },
  },
  mounted() {},
  data() {
    return {
      currentIndex: 1,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    handleSelectionPersonnel(val) {
      this.$emit("handleSelectionPersonnel", val);
    },
    select(selection, row) {
      this.$emit("select", selection, row);
    },
    selectRow(row) {
      this.$nextTick(function() {
        this.$refs.mytable.setCurrentRow(this.tableData[row]);
        const defaultHeight = 468.55;
        let height = this.$refs.mytable.bodyWrapper.scrollHeight;
        if (height > defaultHeight) {
          if (row < 8) {
            this.$refs.mytable.bodyWrapper.scrollTop = 0;
          } else {
            this.$refs.mytable.bodyWrapper.scrollTop = (row - 3) * 56.875;
          }
        } else {
          this.$refs.mytable.bodyWrapper.scrollTop = 0;
        }
      })
    },
    selectThisRow(row) {
      this.$emit("select-this", row);
    }
  },
  computed: {
    // currentIndex() {
    //   return this.currentPage;
    // }
  },
  watch: {
    // currentPage(newVal, oldVal) {
    //   console.log('触发',newVal)
    //   // this.currentIndex = newVal;
    // }
  },
};
</script>
<style lang="less" scoped>
.tables {
  height: 100%;
  box-shadow: 0px 1px 7px 1px rgba(43, 48, 59, 0.2);
  .tabelLists {
    height: calc(100% - 45px);
    // margin-top: 10px;
    .edit {
      color: #4880ff;
      cursor: pointer;
      padding: 0 3px;
    }
  }
  .tabelLists-tow {
    height: 100%;
  }
  .bottom-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding: 0 10px;
    .crumbs,
    .pagenation,
    .rigth-div {
      width: 33.33%;
    }
  }
  .pagenation {
    text-align: center;
  }

  /*带背景的分页按钮背景色begin*/
  /deep/.el-pagination.is-background .el-pager li {
    background-color: #f4f2ff;
    color: #708ed7;
    border: 1px solid #e3e8fb;
    border-radius: 4px;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #708ed7;
    color: #f4f2ff;
  }
  /deep/.el-pagination.is-background .el-pager li.active {
    color: #fff;
    cursor: default;
  }
  /deep/.el-pagination.is-background .el-pager li:hover {
    background-color: #708ed7;
    color: #f4f2ff;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
    background-color: #708ed7;
    color: #f4f2ff;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    background-color: #708ed7;
    color: #f4f2ff;
  }
  /*带背景的分页按钮背景色end*/

  /*不带背景的分页按钮背景色begin*/
  /deep/.el-pager li.active {
    background-color: #708ed7;
    color: #f4f2ff;
    cursor: default;
  }
  /deep/.el-pagination .el-pager li:hover {
    background-color: #708ed7;
    color: #f4f2ff;
  }
  /deep/.el-pagination .el-pager li:not(.disabled):hover {
    background-color: #708ed7;
    color: #f4f2ff;
  }
  /deep/ .el-pagination .btn-prev {
    background-color: #708ed7;
    color: #f4f2ff;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #e3e8fb;
  }
  /deep/ .el-pagination .btn-prev:disabled {
    background-color: #f4f2ff;
    color: #708ed7;
  }
  /deep/ .el-pagination .btn-next {
    background-color: #708ed7;
    color: #f4f2ff;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #e3e8fb;
  }
  /deep/ .el-pagination .btn-next:disabled {
    background-color: #f4f2ff;
    color: #708ed7;
  }
  /*不带背景的分页按钮背景色end*/
  /deep/ .el-pagination .el-pagination__jump .el-input__inner {
    background-color: #f4f2ff;
    color: #708ed7;
  }
  /deep/ .is-checked .el-checkbox__inner::after {
    width: 16px;
    height: 16px;
    background: #a3b3f3;
    border-radius: 50%;
    position: absolute;
    left: 4px;
    top: 4px;
  }

  //勾选框样式
  /deep/ .el-checkbox__inner {
    width: 26px;
    height: 26px;
    border: 1px solid #a3b3f3;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myTable/index.vue